import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { SiteRenderer } from "../components/site/SiteRenderer";

export default function PublicSite() {
  const { slug } = useParams();
  const [site, setSite] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    api.get(`/sites/public/${slug}`).then((r) => { setSite(r.data); document.title = r.data.business_name; }).catch(() => setMissing(true));
  }, [slug]);
  if (missing) return (
    <div className="grid min-h-screen place-items-center p-6 text-center" data-testid="public-site-missing">
      <div><h1 className="text-3xl font-bold">This website isn't live yet</h1><a href="/website-builder" className="mt-4 inline-block font-semibold text-primary">Create your own free website</a></div>
    </div>
  );
  if (!site) return <div className="grid min-h-screen place-items-center"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  return <SiteRenderer site={site} />;
}
